import React, { useEffect, useRef, useState } from 'react'
import './rentReadMe.css'
import { Button, Divider, Image } from 'antd'
import HTMLReactParser from 'html-react-parser/lib/index'
import { useNavigate } from 'react-router-dom'
import { getRentReadMe, getShareList } from '../../api/api'

const RentReadMe = () => {
  const navigate = useNavigate()
  const [info, setInfo] = useState({})
  const jumpToEdit = () => {
    navigate('/editRentReadMe', { state: { state: 'edit', info: info } })
  }
  const [payload, setPayload] = useState({
    page: '1',
    pagesize: '10',
    type: 4,
  })

  useEffect(() => {
    getRentReadMe().then((res) => {
      setInfo(res.data.data)
      console.log(res.data.data)
    })
  }, [payload])
  return (
    <div>
      <div className="rentReadMe">
        <p className="rentReadMetitle">内容信息</p>
        <Divider />

        <div className="rentReadMeContent">
          <div className="contentItem">
            <span className="labelContent">内容首图：</span>
            <Image width={120} src={info.image} />
          </div>

          <div style={{ padding: '0 1.5em' }}>
            {info?.contents?.map((item, index) => {
              return (
                <div>
                  <div className="contentItem">
                    <span className="labelContent">标题{index + 1}:</span>
                    <span> {item.subtitle}</span>
                  </div>

                  <div className="contentItem">
                    <span className="labelContent">内容{index + 1}:</span>
                    <span> {HTMLReactParser(item.text)}</span>
                  </div>

                  <div className="contentItem">
                    <span className="labelContent">图片{index + 1}:</span>
                    <span>
                      {item.images.map((item, index) => {
                        return (
                          <>
                            <Image
                              style={{ margin: 5 }}
                              width={120}
                              src={item}
                            />
                          </>
                        )
                      })}
                    </span>
                  </div>
                  <Divider />
                </div>
              )
            })}
          </div>
        </div>

        <div className="bottomButton">
          <Button type="primary" onClick={jumpToEdit}>
            编辑
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RentReadMe
